module.exports = __webpack_public_path__ + "c9dd86d9bfa9f9565ff0ac08d07f86a4.png";